import { Skeleton } from '@/components/ui/skeleton';

/**
 * Route-level fallback. It mirrors the header-plus-cards shape every screen
 * has, so the layout does not jump when the real page arrives.
 */
const PageSkeleton = () => (
  <div aria-busy="true" aria-live="polite">
    <div className="border-b border-border bg-card">
      <div className="mx-auto flex min-h-16 max-w-7xl items-center px-4 py-3 md:px-6 lg:px-8">
        <Skeleton className="h-7 w-48" />
      </div>
    </div>
    <div className="mx-auto max-w-7xl px-4 py-6 md:px-6 lg:px-8">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <div key={i} className="rounded-lg border border-border bg-card p-5">
            <Skeleton className="mb-3 h-4 w-24" />
            <Skeleton className="mb-2 h-8 w-20" />
            <Skeleton className="h-4 w-full" />
          </div>
        ))}
      </div>
      <div className="mt-4 rounded-lg border border-border bg-card p-5">
        <Skeleton className="mb-4 h-5 w-40" />
        <div className="flex flex-col gap-3">
          {[0, 1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-10 w-full" />
          ))}
        </div>
      </div>
    </div>
    <span className="sr-only">Cargando…</span>
  </div>
);

export default PageSkeleton;
